import React from "react";
import PropTypes from "prop-types";
import { Box, Typography } from "@mui/material";
import CarrierProfileCapabilityType from "../CarrierProfileCapabilityType/CarrierProfileCapabilityType";

export default function CarrierProfileCapabilityTypes({
  typeName,
  allTypes,
  activeCarrier,
  setActiveCarrier,
  isUpdating,
  setIsUpdating
}) {
  return (
    <>
      <Box sx={{ marginBottom: "16px" }}>
        <Typography variant="h4" color="black_opacity.100">
          {typeName}
        </Typography>
      </Box>
      <Box>
        {Object.entries(allTypes).map(([k, v]) => (
          <CarrierProfileCapabilityType
            key={`${k}-type`}
            type={k}
            value={v}
            activeCarrier={activeCarrier}
            setActiveCarrier={setActiveCarrier}
            isUpdating={isUpdating}
            setIsUpdating={setIsUpdating}
          />
        ))
        }
      </Box>
    </>
  );
}

CarrierProfileCapabilityTypes.propTypes = {
  typeName: PropTypes.string.isRequired,
  allTypes: PropTypes.object.isRequired,
  activeCarrier: PropTypes.object.isRequired,
  setActiveCarrier: PropTypes.func.isRequired,
  isUpdating: PropTypes.bool.isRequired,
  setIsUpdating: PropTypes.func.isRequired
};